import React, { useState , useEffect } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from 'react-toastify';


const ContactForm = (props) => {
       var api = "https://script.google.com/macros/s/AKfycbxCU6QJL4LPPv5S8a9TXyXMVBeTi0Sc_-iJQdRxHMtixJll66Q4ZRHOnGcF-fCNpZvc1w/exec";
const [capVal, setCapVal] = useState(null);
const [isDisabled, setIsDisable] = useState(true);

const [forms, setForms] = useState({
  name: '',
  email: '',
  subject: '',
  phone: '',
  company: '',
  message: ''
});

const [validator] = useState(
  new SimpleReactValidator({
    className: 'errorMessage'
  })
);

// force re-render for validator
const [, forceUpdate] = useState();

const changeHandler = (e) => {
  setForms({ ...forms, [e.target.name]: e.target.value });

  if (validator.allValid()) {
    validator.hideMessages();
  } else {
    validator.showMessages();
  }

  forceUpdate(1);
};

useEffect(() => {
  setIsDisable(!capVal);
}, [capVal]);

// API CALL
const sheetApiHandler = async (formData, apiUrl) => {
  const createdby = new Date();

  const formattedDate = createdby.toLocaleString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  const finalData = {
    ...formData,
    CreatedDate: formattedDate
  };

  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(finalData)
    });

    return res;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// SUBMIT HANDLER
const submitHandler = async (e) => {
  e.preventDefault();

//   if (!capVal) {
//     toast("Captcha required");
//     return;
//   }

  setIsDisable(true);

  if (validator.allValid()) {
    validator.hideMessages();

    try {
      // OPTIONAL: fetch dynamic API
      let apiData = "";

      const response = await fetch(api + "?formid=" + e.target.id);
      if (response.ok) {
        const data = await response.json();
        apiData = data?.[0]?.Api_link;
      }

      // use your webhook directly (or apiData if needed)
      await sheetApiHandler(
        forms,
        "https://thakurnrk.app.n8n.cloud/webhook/3653d44a-842e-4b44-a002-d07a9fcadfaa"
      );

      toast("Saved Successfully");

      setForms({
        name: '',
        email: '',
        subject: '',
        phone: '',
        company: '',
        message: ''
      });

    } catch (error) {
      console.error(error);
      toast("Something Went Wrong!", "error");
    }

    setIsDisable(false);

  } else {
    validator.showMessages();
    forceUpdate(1);
    setIsDisable(false);
  }
};

    return (
        <form onSubmit={(e) => submitHandler(e)} id='techstrContactus' className="contact-form">
            <div className="row">
                <div className="col-lg-6">
                    <div className="input-field">
                        <label htmlFor="text1">Name*</label>
                        <div className="input-box">
                            <input
                                value={forms.name}
                                type="text"
                                name="name"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('name', forms.name, 'required|alpha_space')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="input-field">
                        <label htmlFor="text2">Email*</label>
                        <div className="input-box">
                            <input
                                value={forms.email}
                                type="email"
                                name="email"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                                
                            {validator.message('email', forms.email, 'required|email')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field">
                        <label htmlFor="text3">Phone*</label>
                        <div className="input-box">
                            <input
                                value={forms.phone}
                                type="phone"
                                name="phone"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('phone', forms.phone, 'required|phone')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field text-field">
                        <label htmlFor="text5">Message</label>
                        <div className="input-box">
                            <textarea
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                value={forms.message}
                                type="text"
                                name="message"
                                className="form-control"
                                placeholder="How can we help you?">
                            </textarea>
                            {validator.message('message', forms.message, 'required')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                <ReCAPTCHA
              sitekey="6Le-XP4qAAAAAESnzClBlpB3JA1-mUfdy08tepRk"
              onChange={(val) => setCapVal(val)}
               className="custom-recaptcha-class"
            theme="light"
            />
                </div>
            </div>
            <div className="cp-det-btn mt-20 d-grid">


                <button className="cp-btn" type='submit' >Send us a message <i className="fal fa-arrow-right"></i></button>
            </div>
        </form>
    )
}

export default ContactForm;